module.exports = __webpack_public_path__ + "files/a7bf86604869f619df2b88601096a700.png";